import { gql } from '@apollo/client';

export const ChangeAgentTitle = gql`
    mutation changeAgentTitle($agentId: ID!, $title: String!) {
        changeAgentTitle(agentId: $agentId, title: $title) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
